import { render, staticRenderFns } from "./Purchased.vue?vue&type=template&id=bc461d0c&scoped=true&"
import script from "./Purchased.vue?vue&type=script&lang=js&"
export * from "./Purchased.vue?vue&type=script&lang=js&"
import style0 from "./Purchased.vue?vue&type=style&index=0&id=bc461d0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc461d0c",
  null
  
)

export default component.exports